import { jsx, jsxs } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { useMemo } from 'react';
import { IconAttributes16Dimension, IconAttributes16FileSize, IconAttributes16Duration, IconDropdown14Email } from '@fabric-app/icons/svg';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { getResourceDimensions } from '../../../../utils/getResourceDimensions.js';
import { useResourceDataContextSafe } from '../../../../../resource-detail/components/context/resourceDataContext.js';
import { formatFileSize, formatDuration } from '@fabric-app/utils/number';
import { getResourceDuration } from '../../../../utils/getResourceDuration.js';
import { Kind } from '@fabric/woody-client';

const ResourceAttributes = () => {
  const { resource } = useResourceDataContextSafe();
  const attributes = useMemo(() => {
    const result = [];
    const dimensions = getResourceDimensions(resource);
    if (dimensions && dimensions.width && dimensions.height) {
      result.push({
        icon: /* @__PURE__ */ jsx(IconAttributes16Dimension, {}),
        label: `${dimensions.width}x${dimensions.height}`
      });
    }
    if (resource.size) {
      result.push({
        icon: /* @__PURE__ */ jsx(IconAttributes16FileSize, {}),
        label: `${formatFileSize(resource.size)}`
      });
    }
    const duration = getResourceDuration(resource);
    if (duration) {
      result.push({
        icon: /* @__PURE__ */ jsx(IconAttributes16Duration, {}),
        label: `${formatDuration(duration)}`
      });
    }
    if (resource.kind === Kind.EMAIL) {
      result.push({
        icon: /* @__PURE__ */ jsx(IconDropdown14Email, {}),
        label: `Email`
      });
    }
    return result;
  }, [
    resource
  ]);
  if (attributes.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx(Container, {
    children: attributes.map((attribute) => /* @__PURE__ */ jsxs(AttributeItem, {
      children: [
        attribute.icon,
        /* @__PURE__ */ jsx(Label, {
          children: attribute.label
        })
      ]
    }, attribute.label))
  });
};
const Container = styled.div.withConfig({
  displayName: "ResourceAttributes__Container",
  componentId: "sc-ccd178e5-0"
})([
  `display:flex;align-items:center;gap:0.25rem 0.75rem;flex-wrap:wrap;`
]);
const AttributeItem = styled.div.withConfig({
  displayName: "ResourceAttributes__AttributeItem",
  componentId: "sc-ccd178e5-1"
})([
  `display:flex;align-items:center;gap:0.25rem;color:`,
  `;font-size:13px;`
], cssVar["color-text-tertiary"]);
const Label = styled.span.withConfig({
  displayName: "ResourceAttributes__Label",
  componentId: "sc-ccd178e5-2"
})([
  `white-space:nowrap;`
]);

export { ResourceAttributes };
//# sourceMappingURL=ResourceAttributes.js.map
